import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import Container from '~shared/Container'
import Spacer from '~shared/Spacer'

const UnstyledCaseStudyQuote = forwardRef(function UnstyledCaseStudyQuote(
    { author, children, headSpace = '-16px,-56px,', tailSpace = true, ...props },
    ref,
) {
    return (
        <Spacer {...props} head={headSpace} tail={tailSpace} ref={ref}>
            <Container>
                <blockquote>
                    <p>{children}</p>
                    <footer>{author}</footer>
                </blockquote>
            </Container>
        </Spacer>
    )
})

const CaseStudyQuote = styled(UnstyledCaseStudyQuote)`
    blockquote {
        margin: 0;
    }

    p {
        font-size: 20px;
        line-height: 32px;
        margin: 0;
        color: #0c009a;
    }

    p::before {
        content: '\\201C';
    }

    p::after {
        content: '\\201D';
    }

    footer {
        color: #a3a3a3;
        font-size: 14px;
        line-height: 1.5em;
        margin-top: 1em;
    }

    @media ${MqTablet} {
        p {
            font-size: 24px;
            line-height: 40px;
        }

        footer {
            font-size: 16px;
        }
    }

    @media ${MqDesktop} {
        p {
            font-size: 32px;
            line-height: 54px;
        }

        footer {
            font-size: 18px;
        }
    }
`

export default CaseStudyQuote
